import {
    apiCallCenterGetConsultaDetalle,
    apiCallCenterGetHistorialClinico,
    apiGetColaboradoresCallCenterEspecialistas,
    apiReportesDoctores,
    apiReportesDoctoresDescargar,
} from "../settings/apiConfig";
import { createContext, useContext, useState } from "react";
import { fnHandleChangeDate, fnHandleChangeText } from "../settings/handleConfig";
import { getFormFiltro, getModelConsulta } from "../models/MisConsultasModel";

import { Button } from "@material-ui/core";
import { format } from "date-fns";
import { useLayout } from "./LayoutContext";
import { useLogin } from "./LoginContext";
import { useRequest } from "./RequestContext";

export const MisConsultasContext = createContext();

export function MisConsultasProvider(props) {
    const { handleOpenAlert } = useLayout();
    const { usuarioSesion } = useLogin();
    const { Get, GetFile } = useRequest();

    const [usuarioColaborador, setUsuarioColaborador] = useState(null);
    const [listaConsultas, setListaConsultas] = useState([]);
    const [consultaSeleccionada, setConsultaSeleccionada] = useState(getModelConsulta());
    const [entConsulta, setEntConsulta] = useState(null);
    const [historialClinico, setHistorialClinico] = useState(null);
    const [reporteDoctor, setReporteDoctor] = useState(null);
    const [modalOpenDetalleConsulta, setModalOpenDetalleConsulta] = useState(false);
    const [formFiltro, setFormFiltro] = useState(getFormFiltro());

    const handleOpenDetalleConsulta = (value) => {
        setModalOpenDetalleConsulta(value);
    };

    const handleChangeFormFiltroText = fnHandleChangeText(formFiltro, setFormFiltro);
    const handleChangeFormFiltroDate = fnHandleChangeDate(formFiltro, setFormFiltro);

    const handleChangeConsultaSeleccionada = (value) => {
        setConsultaSeleccionada(value);
    };

    const handleClickFiltrarConsultas = () => {
        const { txtFechaDe, txtFechaA, txtEstatusConsulta } = formFiltro;
        const fechaDe = !txtFechaDe.value ? null : txtFechaDe.value.toISOString();
        const fechaA = !txtFechaA.value ? null : txtFechaA.value.toISOString();
        fnObtenerReporte(txtEstatusConsulta.value, fechaDe, fechaA);
    };

    const handleClickRefrescarDatos = () => {
        setFormFiltro(getFormFiltro());
        fnObtenerReporte();
    };

    const handleClickDetalleConsulta = async (iIdConsulta) => {
        await fnObtenerDetalleConsulta(iIdConsulta);
        setModalOpenDetalleConsulta(true);
    };

    const handleClickDescargarReporte = () => {
        const { txtFechaDe, txtFechaA, txtEstatusConsulta } = formFiltro;
        const fechaDe = !txtFechaDe.value ? null : txtFechaDe.value.toISOString();
        const fechaA = !txtFechaA.value ? null : txtFechaA.value.toISOString();
        fnDescargarReporte(txtEstatusConsulta.value, fechaDe, fechaA);
    };

    const handleClickStartMisConsultas = async () => {
        await fnObtenerColaborador();
    };

    const fnObtenerColaborador = async () => {
        const payload = {
            loader: "Consultando información del colaborador...",
            url: apiGetColaboradoresCallCenterEspecialistas + "?piIdUsuarioCGU=" + usuarioSesion.iIdUsuario,
            alert: false,
        };

        const response = await Get(payload);
        if (response.Code === 0) {
            if (response.Result.length < 1) {
                handleOpenAlert("No se ha ingresado con una cuenta de colaborador.");
                setUsuarioColaborador(null);
                return;
            }
            const colaborador = response.Result[0];
            setUsuarioColaborador(colaborador);
        } else {
            setUsuarioColaborador(null);
        }
    };

    const fnObtenerReporte = async (
        psIdEstatusConsulta = "",
        pdtFechaConsultaInicio = null,
        pdtFechaConsultaFin = null
    ) => {
        const payload = {
            loader: "Consultando reporte...",
            url:
                apiReportesDoctores +
                "?psIdColaborador=" +
                usuarioColaborador.iIdColaborador +
                "&psIdEstatusConsulta=" +
                psIdEstatusConsulta +
                "&pdtFechaConsultaInicio=" +
                pdtFechaConsultaInicio +
                "&pdtFechaConsultaFin=" +
                pdtFechaConsultaFin,
            alert: false,
        };

        const response = await Get(payload);
        if (response.Code === 0) {
            if (response.Result.lstDoctores) {
                setReporteDoctor(response.Result);
                const [reporteColaborador] = response.Result.lstDoctores;
                if (reporteColaborador) {
                    setListaConsultas(
                        reporteColaborador.lstConsultas.map((consulta) => ({
                            ...consulta,
                            name: consulta.entPaciente.name,
                            sFechaConsultaInicio:
                                consulta.sEstatusConsulta === "Creado/Programado" ||
                                consulta.sEstatusConsulta === "Cancelado"
                                    ? consulta.sFechaProgramadaInicio
                                    : consulta.sFechaConsultaInicio,
                            sFechaConsultaFin:
                                consulta.sEstatusConsulta === "Creado/Programado" ||
                                consulta.sEstatusConsulta === "Cancelado"
                                    ? consulta.sFechaProgramadaFin
                                    : consulta.sEstatusConsulta === "En consulta"
                                    ? "Consultando"
                                    : consulta.sFechaConsultaFin,
                            sDetalle: (
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => handleClickDetalleConsulta(consulta.iIdConsulta)}
                                >
                                    DETALLE
                                </Button>
                            ),
                        }))
                    );
                } else {
                    setListaConsultas([]);
                    handleOpenAlert("No se encontró información de consultas");
                }
            } else {
                handleOpenAlert("No se encontró información del colaborador");
            }
        }
    };

    const fnDescargarReporte = async (
        psIdEstatusConsulta = "",
        pdtFechaConsultaInicio = "",
        pdtFechaConsultaFin = ""
    ) => {
        const payload = {
            loader: "Descargando reporte...",
            url:
                apiReportesDoctoresDescargar +
                "?psIdColaborador=" +
                usuarioColaborador.iIdColaborador +
                "&psIdEstatusConsulta=" +
                psIdEstatusConsulta +
                "&pdtFechaConsultaInicio=" +
                pdtFechaConsultaInicio +
                "&pdtFechaConsultaFin=" +
                pdtFechaConsultaFin,
            filename: `ReporteDoctores_${usuarioColaborador.iIdColaborador}_${format(
                new Date(),
                "yyyy-MM-dd_HH-mm-ss"
            )}.xlsx`,
            alert: false,
        };

        await GetFile(payload);
    };

    const fnObtenerDetalleConsulta = async (piIdConsulta) => {
        const payload = {
            loader: "Obteniendo detalle de consulta",
            url: apiCallCenterGetConsultaDetalle + "?piIdConsulta=" + piIdConsulta,
            alert: false,
        };

        const response = await Get(payload);
        if (response.Code === 0) {
            const [consulta] = response.Result;
            if (consulta) {
                setEntConsulta(consulta);
                await fnObtenerDetalleHistoriaClinica(piIdConsulta);
            } else {
                setEntConsulta(null);
                handleOpenAlert("No se encontró la consulta");
            }
        }
    };

    const fnObtenerDetalleHistoriaClinica = async (piIdConsulta) => {
        const payload = {
            loader: "Obteniendo detalle de historial clínico",
            url: apiCallCenterGetHistorialClinico + "?piIdConsulta=" + piIdConsulta,
            alert: false,
        };

        const response = await Get(payload);
        if (response.Code === 0) {
            const [historia] = response.Result;
            if (historia) {
                setHistorialClinico(historia);
            } else {
                setHistorialClinico(null);
            }
        }
    };

    return (
        <MisConsultasContext.Provider
            value={{
                usuarioColaborador,
                listaConsultas,
                consultaSeleccionada,
                entConsulta,
                historialClinico,
                reporteDoctor,
                modalOpenDetalleConsulta,
                formFiltro,
                handleOpenDetalleConsulta,
                handleChangeFormFiltroText,
                handleChangeFormFiltroDate,
                handleChangeConsultaSeleccionada,
                handleClickFiltrarConsultas,
                handleClickRefrescarDatos,
                handleClickDetalleConsulta,
                handleClickDescargarReporte,
                handleClickStartMisConsultas,
            }}
        >
            {props.children}
        </MisConsultasContext.Provider>
    );
}

export function useMisConsultas() {
    return useContext(MisConsultasContext);
}
